import apiCompetitions from '@/api/competition'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  addCompetitionTrainersStart:
    '[add competition Trainers] Create competition Trainers start',
  addCompetitionTrainersSuccess:
    '[add competition Trainers] Create competition Trainers success',
  addCompetitionTrainersFailure:
    '[add competition Trainers] Create competition Trainers failure',
}

export const actionTypes = {
  addCompetitionTrainers:
    '[add competition Trainers] Create competition Trainers',
}

const mutations = {
  [mutationTypes.addCompetitionTrainersStart](state) {
    state.isSubmitting = true
    state.error = null
  },

  [mutationTypes.addCompetitionTrainersSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.addCompetitionTrainersFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.addCompetitionTrainers](context, {trainer, id}) {
    context.commit(mutationTypes.addCompetitionTrainersStart)
    return new Promise((resolve) => {
      apiCompetitions
        .addCompetitionTrainers(trainer, id)
        .then((response) => {
          context.commit(mutationTypes.addCompetitionTrainersSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.addCompetitionTrainersFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
